import { render, staticRenderFns } from "./add-classify.vue?vue&type=template&id=04c29d10&scoped=true&"
import script from "./add-classify.vue?vue&type=script&lang=js&"
export * from "./add-classify.vue?vue&type=script&lang=js&"
import style0 from "./add-classify.vue?vue&type=style&index=0&id=04c29d10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c29d10",
  null
  
)

export default component.exports